<template>
  <v-responsive
    class="mx-auto"
    max-width="1350"
  >
    <v-container fluid>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          sm="4"
          md="4"
        >
          <base-info-card
            align="center"
            v-bind="card"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-responsive>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      cards: [
        {
          color: 'light-green darken-3',
          icon: 'mdi-school-outline',
          title: 'Learn & Grow',
          text: 'We love discovering, refactoring, optimizing and trying out new languages, frameworks and technology. Learning never stops here!',
        },
        {
          color: 'light-green darken-3',
          icon: 'mdi-account-hard-hat',
          title: 'Work Hard , Play Hard',
          text: 'This is the motto we live by. We are serious about coding and client satisfaction, but also movie nights and weekend retreats.',
        },
        {
          color: 'light-green darken-3',
          icon: 'mdi-gift',
          title: 'Just Some Benifits',
          text: 'Gym membership. Flexible working hours. Stocked pantry. Medical insurance. Project based bonuses. Need we say more?',
        },
      ],
    }),
  }
</script>
